import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const FreightPage = lazy(() => import('../components/freight'));
const LogisticsModule = lazy(() => import('../components/freight/logistics'));
const WarehousingOverviewPage = lazy(() => import('../components/warehousing'));
const ArgentsPage = lazy(() => import('../components/warehousing/argents'));
const OplogPage = lazy(() => import('../components/warehousing/oplog'));
const TransfersPage = lazy(() => import('../components/warehousing/transfers'));
// One page for every warehouse we run ourselves — the site comes from the
// route, so opening another is a registry row rather than a new route.
const OwnWarehousePage = lazy(() => import('../components/warehousing/own'));

export const logisticsRoutes = (
  <>
    <Route path="/freight" element={<FreightPage />} />
    <Route path="/freight/logistics/*" element={<LogisticsModule />} />
    <Route path="/warehousing" element={<WarehousingOverviewPage />} />
    <Route path="/warehousing/argents" element={<ArgentsPage />} />
    <Route path="/warehousing/oplog" element={<OplogPage />} />
    <Route path="/warehousing/transfers" element={<TransfersPage />} />
    <Route path="/warehousing/own/:code" element={<OwnWarehousePage />} />
  </>
);
